export default __webpack_public_path__ + "static/1047-5cb6a72339e6a4d10a5f2a802e54be55.gif";